import http from "./http.js"
/**
 * post、get、put
 * http.post('url', params);
 * url:接口
 * params:参数
    {
      header:{
        type:'',
        role:''
      },
      body:{

      },
      query:{

      }
    }
 */

//系统用户登录 (获取 Jwt 授权数据) 钉钉扫码登录
export const userLogin = params => {
  return http.post("/token", params)
}
export const postVisitorManage = params => {
  return http.post("/visitor_manage", params)
}
export const getHospitalList = params => {
  return http.postres("/visitor_manage", params)
}


// WEBPACK FOOTER //
// ./src/modules/workorder/api/api.js